<template>
    <div>
        <el-card>
            <el-row class="user-sign__title"> 用户标签统计 </el-row>
            <el-row class="user-sign__search">
                <span>标签名称</span>
                <el-input v-model="searchList.name" placeholder="请输入" style="width: 200px"></el-input>
                <span>分类</span>
                <el-select v-model="searchList.signType" filterable placeholder="请选择" style="width: 200px" clearable>
                    <el-option v-for="item in signTypeList" :key="item.value" :label="item.name"
                        :value="item.value"></el-option>
                </el-select>
                <span>渠道</span>
                <el-select v-model="searchList.channel" filterable placeholder="请选择" style="width: 200px" clearable>
                    <el-option v-for="item in channelList" :key="item.channelId" :label="item.name" :value="item.value">
                    </el-option>
                </el-select>
                <span>国家</span>
                <el-select v-model="searchList.countryCode" filterable placeholder="请选择">
                    <el-option v-for="item in countryList" :key="item.countryCode" :label="item.country"
                        :value="item.countryCode">
                    </el-option>
                </el-select>
                <span>模板</span>
                <el-select v-model="searchList.signTemplate" placeholder="请选择" style="width: 100px" clearable>
                    <el-option v-for="item in signTemplateList" :key="item.value" :label="item.name"
                        :value="item.value"></el-option>
                </el-select>
                <span>状态</span>
                <el-select v-model="searchList.valid" placeholder="请选择" style="width: 100px" clearable>
                    <el-option key="0" label="下线" value="0"> </el-option>
                    <el-option key="1" label="上线" value="1"> </el-option>
                </el-select>
            </el-row>
            <el-row>
                <el-button style="margin-left: 10px" type="primary" @click="getUserSigns(1)">查询</el-button>
                <el-button style="margin-left: 10px" type="primary" @click="handleUserSignStatistic">人数查询</el-button>
            </el-row>
            <!-- 表格 -->
            <el-row>
                <el-table border :data="userSignList" @selection-change="handleSelectionChange" v-loading="loading">
                    <el-table-column type="selection" width="55">
                    </el-table-column>
                    <el-table-column type="index" label="序号" align="center">
                    </el-table-column>
                    <el-table-column prop="name" label="标签名称" align="center">
                    </el-table-column>
                    <el-table-column prop="signType" label="分类" align="center">
                    </el-table-column>
                    <el-table-column prop="channel" label="渠道" align="center">
                        <template slot-scope="scope">
                            <el-popover placement="top-start" width="400" trigger="hover"
                                v-if="scope.row.channel && scope.row.channel.length > 100">
                                <div>{{ scope.row.channel }}</div>
                                <div slot="reference" class="channel-content">
                                    {{ scope.row.channel.substring(0, 100) }}
                                    <span class="view-more">查看更多</span>
                                </div>
                            </el-popover>
                            <span v-else>{{ scope.row.channel }}</span>

                        </template>
                    </el-table-column>
                    <el-table-column prop="countryCode" label="国家" align="center">
                    </el-table-column>
                    <el-table-column prop="signTemplate" label="模板" align="center">
                    </el-table-column>
                    <el-table-column prop="signTemplate" label="内容" align="center">
                    </el-table-column>
                    <el-table-column prop="remark" label="备注信息" align="center">
                    </el-table-column>
                    <el-table-column prop="priority" label="优先级" sortable align="center">
                    </el-table-column>
                    <el-table-column prop="operator" label="操作人" align="center">
                    </el-table-column>
                    <el-table-column prop="mtime" label="修改时间" align="center" :formatter="formatDate">
                    </el-table-column>
                    <el-table-column label="状态" align="center">
                        <template slot-scope="scope">
                            {{ scope.row.valid === 0 ? '下线' : '上线' }}
                        </template>
                    </el-table-column>
                    <el-table-column label="人数" width="200">
                        <template slot-scope="scope">
                            <div class="info-box" v-if="scope.row.signType === 'match'">
                                <p>总人数：<span
                                        @click="getUserSignStatisticDetail(scope.row.onlineUidSet, scope.row.freeUidSet, scope.row.matchingUidSet, scope.row.MatchCallUidSet)">{{
                                            scope.row.totalNum || " " }}</span></p>
                                <p>在线人数：<span @click="getUserSignStatisticDetail(scope.row.onlineUidSet)">{{
                                    scope.row.onlineNum || " " }}</span></p>
                                <p>匹配中人数：<span @click="getUserSignStatisticDetail(scope.row.matchingUidSet)">{{
                                    scope.row.matchingNum || " " }}</span></p>
                                <p>匹配通话中人数：<span @click="getUserSignStatisticDetail(scope.row.MatchCallUidSet)">{{
                                    scope.row.MatchCallNum || " " }}</span></p>
                            </div>
                            <div class="info-box" v-else>
                                <p>总人数：<span
                                        @click="getUserSignStatisticDetail(scope.row.onlineUidSet, scope.row.freeUidSet, scope.row.matchingUidSet, scope.row.MatchCallUidSet)">{{
                                            scope.row.totalNum || " " }}</span></p>
                                <p>在线人数：<span @click="getUserSignStatisticDetail(scope.row.onlineUidSet)">{{
                                    scope.row.onlineNum || " " }}</span></p>
                                <p>忙线人数：<span @click="getUserSignStatisticDetail(scope.row.busyUidSet)">{{
                                    scope.row.busyNum || " " }}</span></p>
                                <p>live人数：<span @click="getUserSignStatisticDetail(scope.row.liveUidSet)">{{
                                    scope.row.liveNum || " " }}</span></p>
                            </div>
                        </template>
                    </el-table-column>
                </el-table>
            </el-row>
            <!-- 分页 -->
            <el-row>
                <el-pagination background layout="prev, pager, next" :total="this.totalPage" :page-size="pageSize"
                    :current-page.sync="currentPage" @current-change="guaranteedHandleCurrentChange">
                </el-pagination>
            </el-row>
        </el-card>
        <el-card style="margin-top: 20px" v-if="isShowDetail">
            <el-row class="user-sign__title"> 详情 </el-row>
            <el-table border :data="userSignStatisticDetailShowList" v-loading="loadingDetail">
                <!-- 基础字段 -->
                <el-table-column prop="channel" label="渠道" align="center"></el-table-column>
                <el-table-column prop="identity" label="身份" align="center"></el-table-column>
                <el-table-column prop="rid" label="ID" align="center"></el-table-column>
                <el-table-column prop="name" label="名称" align="center"></el-table-column>
                <el-table-column prop="avatar" label="头像" align="center">
                    <template slot-scope="scope">
                        <el-image style="width: 50px; height: 50px" :src="scope.row.avatar"
                            :preview-src-list="[scope.row.avatar]">
                        </el-image>
                    </template>
                </el-table-column>
                <el-table-column prop="country" label="国家" align="center"></el-table-column>
                <el-table-column prop="countryCode" label="国家代码" align="center"></el-table-column>
                <el-table-column prop="registerTime" label="注册时间" align="center"></el-table-column>
                <el-table-column prop="registerDays" label="注册天数" align="center"></el-table-column>
                <el-table-column prop="lastActiveTime" label="上次活跃时间" align="center"></el-table-column>
                <!-- <el-table-column prop="totalOnlineTime" label="累计在线时长" align="center"></el-table-column> -->
                <el-table-column prop="gender" label="性别" align="center">
                    <template slot-scope="scope">
                        {{ scope.row.gender === 1 ? '男' : '女' }}
                    </template>
                </el-table-column>

                <!-- 主播特有字段 -->
                <template v-if="showType !== 'user'">
                    <el-table-column prop="isGreenHost" label="是否绿色主播" align="center">
                        <template slot-scope="scope">
                            {{ scope.row.isGreenHost ? '是' : '否' }}
                        </template>
                    </el-table-column>
                    <el-table-column prop="isPureGreenHost" label="是否纯绿色主播" align="center">
                        <template slot-scope="scope">
                            {{ scope.row.isPureGreenHost ? '是' : '否' }}
                        </template>
                    </el-table-column>
                    <el-table-column prop="isBeautifulHost" label="是否beautiful主播" align="center">
                        <template slot-scope="scope">
                            {{ scope.row.isBeautifulHost ? '是' : '否' }}
                        </template>
                    </el-table-column>
                    <el-table-column prop="isBeautifulHost" label="是否能进入推荐列表" align="center">
                        <template slot-scope="scope">
                            {{ scope.row.recommendFlag ? '是' : '否' }}
                        </template>
                    </el-table-column>
                    <!-- <el-table-column prop="isPrivateRoomHost" label="是否包间主播" align="center">
                        <template slot-scope="scope">
                            {{ scope.row.isPrivateRoomHost ? '是' : '否' }}
                        </template>
                    </el-table-column> -->
                    <el-table-column prop="agentName" label="代理名称" align="center"></el-table-column>
                    <el-table-column prop="hostLevel" label="主播等级" align="center"></el-table-column>
                </template>

                <!-- 用户特有字段 -->
                <template v-if="showType === 'user'">
                    <el-table-column prop="isMember" label="是否会员" align="center">
                        <template slot-scope="scope">
                            {{ scope.row.isMember ? '是' : '否' }}
                        </template>
                    </el-table-column>
                    <el-table-column prop="hasRecharge" label="是否充值" align="center">
                        <template slot-scope="scope">
                            {{ scope.row.hasRecharge ? '是' : '否' }}
                        </template>
                    </el-table-column>
                    <el-table-column prop="rechargeCoins" label="充值金币" align="center"></el-table-column>
                    <el-table-column prop="rechargeUsd" label="充值美金" align="center"></el-table-column>
                </template>
            </el-table>
            <!-- 分页 -->
            <el-row>
                <el-pagination background layout="prev, pager, next" :total="this.detailTotal"
                    :page-size="detailPageSize" :current-page.sync="detailPage" @current-change="changeDetailPage">
                </el-pagination>
            </el-row>
        </el-card>
    </div>
</template>
<script>
export default {
    data() {
        return {
            searchList: {
                name: '',
                signType: '',
                channel: '',
                countryCode: '',
                signTemplate: '',
                valid: ''
            },
            //分类列表
            signTypeList: [],
            //渠道列表
            channelList: [],
            //国家列表
            countryList: [],
            //模板列表
            signTemplateList: [],
            currentPage: 1,
            totalPage: 0,
            userSignList: [],
            pageSize: 30,
            userSignStatisticList: [],
            loading: false,
            userSignStatisticDetailList: [],
            userSignStatisticDetailShowList: [],
            loadingDetail: false,
            detailPage: 1,
            detailTotal: 0,
            detailPageSize: 30,
            showType: 'user',
            isShowDetail: false,
        }
    },
    created() {
        this.getSignType()
        this.getChannel()
        this.getCountryCode()
        this.getSignTemplate()
    },
    methods: {
        //人数查询
        handleUserSignStatistic() {
            if (this.userSignStatisticList.length == 0) {
                return this.$message.error('请选择要查询的标签')
            }
            let userSignType = this.userSignStatisticList[0].signType;
            let signTemplateType = this.userSignStatisticList[0].signTemplate;
            this.showType = this.userSignStatisticList[0].signTemplate

            const hasMismatch = this.userSignStatisticList.some(item => {
                if (item.signType != userSignType) {
                    this.$message.error('请选择同一分类的标签')
                    return true
                }
                if (item.signTemplate != signTemplateType) {
                    this.$message.error('请选择同一模板的标签')
                    return true
                }
                return false
            })

            if (hasMismatch) {
                return
            }

            let info = {
                signList: this.userSignStatisticList.map(item => item.name),
                userSignType: userSignType,
                signTemplateType: signTemplateType,
            }
            this.getUserSignStatistic(info)
        },
        //修改当前页
        guaranteedHandleCurrentChange(page) {
            this.getUserSigns(page)
        },
        handleSelectionChange(val) {
            this.userSignStatisticList = val
        },
        formatDate(row, column) {
            // 获取单元格数据
            let data = row[column.property] * 1000
            if (data == null) {
                return null
            }
            let dt = new Date(data)
            return (
                dt.getFullYear() +
                '-' +
                (dt.getMonth() + 1) +
                '-' +
                dt.getDate() +
                ' ' +
                dt.getHours() +
                ':' +
                dt.getMinutes() +
                ':' +
                dt.getSeconds()
            )
        },
        // 获取分类选项
        async getSignType() {
            const { data: res } = await this.$axios({
                method: 'GET',
                url: this.$store.getters.path.const_all,
                params: {
                    username: this.$store.getters.username,
                    token: this.$store.getters.token,
                    className: 'com.quhong.enums.UserSignType',
                },
            })

            if (res.code != 0) {
                return this.$message.error(res.msg)
            } else {
                this.signTypeList = res.data
            }
        },
        // 获取渠道选项
        async getChannel() {
            const { data: res } = await this.$axios({
                method: 'POST',
                url:
                    this.$store.getters.path.channelList +
                    '?username=' +
                    this.$store.getters.username +
                    '&token=' +
                    this.$store.getters.token,
            })

            if (res.code != 0) {
                return this.$message.error(res.msg)
            } else {
                this.channelList = [
                    { channelId: -1, name: 'all', value: 'all' },
                    ...res.data,
                ]
            }
        },
        // 获取国家选项
        async getCountryCode() {
            const { data: res } = await this.$axios({
                method: 'POST',
                url:
                    this.$store.getters.path.normal_country +
                    '?username=' +
                    this.$store.getters.username +
                    '&token=' +
                    this.$store.getters.token,
            })

            if (res.code != 0) {
                return this.$message.error(res.msg)
            } else {
                this.countryList = res.data.countryList
            }
        },
        // 获取模板选项
        async getSignTemplate() {
            const { data: res } = await this.$axios({
                method: 'GET',
                url: this.$store.getters.path.const_all,
                params: {
                    username: this.$store.getters.username,
                    token: this.$store.getters.token,
                    className: 'com.quhong.enums.UserSignTemplateType',
                },
            })

            if (res.code != 0) {
                return this.$message.error(res.msg)
            } else {
                this.signTemplateList = res.data
            }
        },
        //获取用户标签列表
        async getUserSigns(page) {
            if (this.loading) {
                return
            }
            this.loading = true
            let curPage = page || this.currentPage
            let userSignData = {
                data: this.searchList,
                page: curPage,
            }

            const { data: res } = await this.$axios({
                method: 'POST',
                withCredentials: true,
                headers: {
                    'Content-Type': 'application/json; charset=UTF-8',
                },
                url: this.$store.getters.path.config_userSign_query,
                data: userSignData,
                params: {
                    username: this.$store.getters.username,
                    token: this.$store.getters.token,
                },
            })
            this.loading = false
            if (res.code != 0) {
                return this.$message.error(res.msg)
            } else {
                this.userSignList = res.data.list
                this.totalPage = res.data.total
            }
        },
        //获取用户标签人数
        async getUserSignStatistic(info) {
            if (this.loading) {
                return
            }
            this.loading = true
            const { data: res } = await this.$axios({
                method: 'POST',
                url: this.$store.getters.path.config_userSign_statistic,
                params: {
                    username: this.$store.getters.username,
                    token: this.$store.getters.token,
                },
                data: info,
            })
            this.loading = false
            if (res.code != 0) {
                return this.$message.error(res.msg)
            } else {
                // 创建一个Map来存储返回的数据，以name为key
                const dataMap = new Map(res.data.map(item => [item.userSignName, item]));

                // 只遍历一次userSignList
                this.userSignList.forEach(item => {
                    const matchedData = dataMap.get(item.name);
                    if (matchedData) {
                        this.$set(item, 'onlineNum', matchedData.onlineNum);
                        this.$set(item, 'freeNum', matchedData.freeNum);
                        this.$set(item, 'busyNum', matchedData.busyNum);
                        this.$set(item, 'liveNum', matchedData.liveNum);
                        this.$set(item, 'matchingNum', matchedData.matchingNum);
                        this.$set(item, 'MatchCallNum', matchedData.MatchCallNum);
                        this.$set(item, 'onlineUidSet', matchedData.onlineUidSet);
                        this.$set(item, 'freeUidSet', matchedData.freeUidSet);
                        this.$set(item, 'busyUidSet', matchedData.busyUidSet);
                        this.$set(item, 'liveUidSet', matchedData.liveUidSet);
                        this.$set(item, 'matchingUidSet', matchedData.matchingUidSet);
                        this.$set(item, 'MatchCallUidSet', matchedData.MatchCallUidSet);
                        this.$set(item, 'totalNum', matchedData.onlineNum || 0 + matchedData.freeNum || 0 + matchedData.busyNum || 0 + matchedData.liveNum || 0 + matchedData.matchingNum || 0 + matchedData.MatchCallNum || 0);
                    }
                });
            }
        },
        //获取用户标签人数详情
        async getUserSignStatisticDetail(...args) {
            if (this.loadingDetail) return
            this.loadingDetail = true
            let uidSet = [...args].flat().filter(item => item)
            if (uidSet.length == 0) {
                return this.$message.error('请选择要查询的uid')
            }
            this.loadingDetail = true
            const { data: res } = await this.$axios({
                method: 'POST',
                url: this.$store.getters.path.config_userSign_statistic_detail,
                params: {
                    username: this.$store.getters.username,
                    token: this.$store.getters.token,
                },
                data: {
                    uidSet
                },
            })
            this.loadingDetail = false
            if (res.code != 0) {
                return this.$message.error(res.msg)
            } else {
                this.isShowDetail = true
                this.userSignStatisticDetailList = res.data
                this.detailTotal = res.data.length
                this.userSignStatisticDetailShowList = res.data.slice((this.detailPage - 1) * this.detailPageSize, this.detailPage * this.detailPageSize)
            }
        },
        changeDetailPage(page) {
            this.detailPage = page
            this.userSignStatisticDetailShowList = this.userSignStatisticDetailList.slice((this.detailPage - 1) * this.detailPageSize, this.detailPage * this.detailPageSize)
        }
    }
}
</script>
<style scoped lang="scss">
.user-sign {
    &__title {
        font-size: 28px;
        font-weight: 700;
        margin-bottom: 20px;
    }

    &__search {
        span {
            font-size: 20px;
            font-weight: 600;
            margin-right: 15px;
            margin-left: 15px;
        }

        .searchBtn {
            margin-left: 10px;
        }
    }
}

.channel-content {
    cursor: pointer;

    .view-more {
        color: #409EFF;
        margin-left: 5px;
    }
}

.info-box {
    span {
        color: #409EFF;
        cursor: pointer;
    }
}
</style>